export const AUTO_WORKER_POLL_MS = 15_000;
export const AUTO_WORKER_SUCCESS_DELAY_MS = 5_000;
export const AUTO_WORKER_BLOCKED_DELAY_MS = 30_000;
export const AUTO_WORKER_MAX_BACKOFF_MS = 120_000;

export function chooseAutoWorkerJob(jobs, { participantId, isEligible }) {
  return [...(jobs || [])]
    .filter((job) => job?.state === "queued")
    .filter((job) => String(job.consumerId || "").toLowerCase() !== String(participantId || "").toLowerCase())
    .filter((job) => isEligible(job))
    .sort((left, right) => Date.parse(left.createdAt) - Date.parse(right.createdAt))[0] || null;
}

export function getAutoWorkerDelay(outcome, consecutiveFailures = 0) {
  if (outcome === "submitted") return AUTO_WORKER_SUCCESS_DELAY_MS;
  if (outcome === "blocked") return AUTO_WORKER_BLOCKED_DELAY_MS;
  if (outcome === "failed") {
    return Math.min(AUTO_WORKER_MAX_BACKOFF_MS, 10_000 * (2 ** Math.max(0, consecutiveFailures - 1)));
  }
  return AUTO_WORKER_POLL_MS;
}
